module.exports = __webpack_public_path__ + "static/media/Logo.acfa4dbe.svg";